import script from "./SearchForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchForm.vue?vue&type=script&setup=true&lang=ts"

import "./SearchForm.vue?vue&type=style&index=0&id=9e60c574&lang=scss&scoped=true"

import exportComponent from "/builds/ext/ERCO/productdata-archive-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9e60c574"]])

export default __exports__